import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { intlShape, injectIntl } from 'react-intl';
import {
  Modal,
  ModalButtons,
  ModalContent,
  Button,
  ProgressBar,
  Chip,
  Label,
  withForm,
} from 'mw-style-react';
import AppUtils from '@control-front-end/utils/utils';
import Yup from 'yup';
import { SEND_INVITE } from 'constants';
import { MAILTO_REGEX } from '@control-front-end/common/constants/regExp';
import cn from 'classnames';
import mes from './intl';
// eslint-disable-next-line no-unused-vars
import sModal from '../../Modal.scss'; // NOSONAR
// eslint-disable-next-line no-unused-vars
import sLocal from './Invite.scss'; // NOSONAR

class Invite extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      focus: false,
      value: '',
    };
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputKeyUp = this.handleInputKeyUp.bind(this);
    this.handleInputKeyDown = this.handleInputKeyDown.bind(this);
  }

  // Ф-ция локализации
  i(mesId, values) {
    return AppUtils.getMes(this.context)(mesId, values);
  }

  handleLoginDelete(login) {
    const { values, handleOnChange } = this.props;
    const arr = values.logins.slice();
    const index = arr.findIndex((i) => i.id === login);
    arr.splice(index, 1);
    const error = arr.length === 0;
    handleOnChange({ id: 'logins', value: arr, error });
  }

  renderBadges(logins) {
    if (!logins.length) return null;
    return logins.map((login) => (
      <Chip
        key={login}
        label={login}
        type="rectangular"
        closeClick={() => this.handleLoginDelete(login)}
      />
    ));
  }

  findLogin() {
    const { value } = this.state;
    const { values, handleOnChange } = this.props;
    const logins = values.logins.slice();
    if (!value.length) return;
    if (!logins.includes(value)) {
      logins.push(value);
    }
    const error = logins.length === 0;
    handleOnChange({ id: 'logins', value: logins, error });
    this.setState({ value: '' });
  }

  handleInputChange(e) {
    const value = e.target.value.trim();
    this.setState({ value });
  }

  handleInputKeyUp(e) {
    if (e.key === 'Enter') {
      this.findLogin();
    }
  }

  handleInputKeyDown(e) {
    const { value } = this.state;
    const { values } = this.props;
    const logins = values.logins.slice();
    if (e.key === 'Backspace' && logins.length > 0 && !value.length) {
      this.handleLoginDelete(logins.pop());
    }
  }

  handleInputFocus() {
    if (this.input) this.input.focus();
    this.setState({ focus: true });
  }

  handleInputBlur() {
    this.setState({ focus: false });
    this.findLogin();
  }

  render() {
    const { values, errors, visibility, onClose, handleSubmit, isSubmit } =
      this.props;

    const { focus, value } = this.state;

    return (
      <Modal
        styleName="sModal.modal"
        visibility={visibility}
        onClose={onClose}
        label={this.i(mes.inviteMembers)}
        size="large"
      >
        <ModalContent styleName="sModal.modal__content">
          <Label
            styleName="sLocal.login__helper"
            value={this.i(mes.sendInviteHelper)}
          />
          <Label
            value={this.i(mes.loginName)}
            styleName={cn('sLocal.login__label', {
              'sLocal.error': !!errors.logins || false,
            })}
          />
          <div
            styleName={cn('sLocal.login', {
              'sLocal.focus': focus,
              'sLocal.error': !!errors.logins || false,
            })}
            onClick={this.handleInputFocus}
          >
            {this.renderBadges(values.logins)}
            <input
              ref={(el) => (this.input = el)}
              styleName="sLocal.login__input"
              onFocus={this.handleInputFocus}
              onBlur={this.handleInputBlur}
              onChange={this.handleInputChange}
              onKeyUp={this.handleInputKeyUp}
              onKeyDown={this.handleInputKeyDown}
              autoFocus={true}
              value={value}
            />
          </div>
        </ModalContent>
        <ModalButtons styleName="sModal.modal__buttons">
          <Button
            label={this.i(mes.sendInvite)}
            size="large"
            onClick={handleSubmit}
            visibility={isSubmit ? 'disabled' : 'visible'}
          />
          <ProgressBar
            styleName="sModal.modal__loader"
            type="circle"
            size="small"
            visibility={isSubmit ? 'visible' : 'hidden'}
          />
        </ModalButtons>
      </Modal>
    );
  }
}

const FormInvite = withForm(
  {
    mapPropsToValues() {
      return {
        logins: [],
      };
    },
    yup: Yup.object().shape({
      logins: Yup.array().required(''),
    }),
    handleSubmit: (values, dispatch, formActions, props) => {
      formActions.onClose = props.onClose;
      const { logins } = values;
      const isEmail = (str) => {
        const re = new RegExp(MAILTO_REGEX);
        return re.test(String(str));
      };
      const invitations = logins.map((i) => ({
        login: i.toString(),
        email: isEmail(i) ? i : undefined,
      }));
      dispatch({
        type: SEND_INVITE.REQUEST,
        payload: {
          invitations,
          formActions,
        },
      });
    },
  },
  Invite
);

Invite.propTypes = {
  visibility: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleOnChange: PropTypes.func,
  isSubmit: PropTypes.bool,
  values: PropTypes.object,
  errors: PropTypes.object,
};

Invite.contextTypes = {
  intl: intlShape,
};

export default injectIntl(FormInvite);
